// extracted by mini-css-extract-plugin
export default {"layout":"Share_layout__21U96","button":"Share_button__NXakl","img":"Share_img__2out3","shareList":"Share_shareList__mUppe","share":"Share_share__a2pau"};